import { ModifiedIncident } from "../components/services/account/profile/incidents/get-support/dialog"

export const defaultIncident: ModifiedIncident = {
  incidentType: "AuthorizationRequest",
  description: "",
  exhibitionId: process.env.NEXT_PUBLIC_WEBSHOP_XRM_EVENT_ID,
}
